import { HttpClient } from "@angular/common/http";
import { effect, inject, Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { UserModel, UserModelGo } from "./user.model";
import { authorizeHttp } from "../../util/authorize-http";
import { AuthService } from "../auth/auth.service";
import { map } from "rxjs";
import { mapUserFromGo } from "../../../feature/team/team.service";

@Injectable({ providedIn: 'root' })
export class UserServiceRds {

  authService = inject(AuthService);
  http = authorizeHttp(inject(HttpClient), this.authService.accessTokenReadOnly);
  userInfoSent = false;

  constructor() {
    effect(() => {
      if (!this.userInfoSent && this.authService.accessTokenReadOnly()) {
        this.postUserInfo();
        this.userInfoSent = true;
      }
    });
  }

  findUsers(search: string) {
    const params = [
      `page-size=10`,
      `page=0`,
    ];
    if (search) {
      params.push(`search=${search}`);
    }
    return this.http.get<UserModel[]>(`${environment.baseUrlRds}/functions/agent-search?${params.join('&')}`);
  }

  postUserInfo() {
    this.http.post<{
      "id": string,
      "type": "user",
      "created": string,
      "modified": string,
      "givenName": string,
      "familyName": string,
      "email": string,
      "manager": string,
      "picture": string,
      "externalId": string,
      "createdByLogin": boolean
    }>(`${environment.baseUrlRds}/user/login`, {}).subscribe(data => {
      this.authService.userID.set(data.id);
    });
  }

  getUser(userID: string) {
    return this.http.get<UserModelGo[]>(`${environment.baseUrlRds}/data/users/${userID}/`).pipe(map(users => mapUserFromGo(users[0])));
  }
}
